import { render, staticRenderFns } from "./PillarTitle.vue?vue&type=template&id=c1bd3b3c&scoped=true&"
import script from "./PillarTitle.vue?vue&type=script&lang=js&"
export * from "./PillarTitle.vue?vue&type=script&lang=js&"
import style0 from "./PillarTitle.vue?vue&type=style&index=0&id=c1bd3b3c&lang=scss&scoped=true&"
import style1 from "./PillarTitle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bd3b3c",
  null
  
)

export default component.exports